"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseIcon = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var BaseIcon_module_scss_1 = __importDefault(require("./BaseIcon.module.scss"));
var BaseIcon = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, className = _a.className, children = _a.children, size = _a.size, dataTestId = _a.dataTestId;
    var sizes = {
        'extra-small': '14',
        small: '16',
        medium: '24',
        large: '32',
        'extra-large': '48',
    };
    return (react_1.default.createElement("svg", { "aria-hidden": title === '', className: (0, classnames_1.default)(BaseIcon_module_scss_1.default.icon, className), "data-jlds": true, "data-testid": dataTestId, height: sizes[size], role: "img", viewBox: "0 0 ".concat(sizes[size], " ").concat(sizes[size]), width: sizes[size], xmlns: "http://www.w3.org/2000/svg" },
        title && react_1.default.createElement("title", null, title),
        children));
};
exports.BaseIcon = BaseIcon;
//# sourceMappingURL=BaseIcon.js.map